import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import type { Nullable } from '@hrlogics/helper-types';

import type { EmploymentDataInfoFragment } from 'src/api';
import { Modal, ModalTopAction } from 'src/components/common';
import { PositionDetailsContent } from 'src/components/position';
import { ModalId } from 'src/constants/modals';
import { useScreenInfo } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';

export type PositionDetailsModalArgs = {
  employmentData: Nullable<EmploymentDataInfoFragment>;
  onDataDispute: (companyId: string) => void;
};

export const PositionDetailsModal: React.FC = () => {
  const { closeModal, isOpen, args } = useModal<PositionDetailsModalArgs>(ModalId.PositionDetails);

  const { isMobile } = useScreenInfo();

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const mobileTopAction = React.useMemo((): ModalTopAction => {
    return {
      show: true,
      render: () => (
        <IconButton onClick={() => onCloseModal()}>
          <CloseIcon />
        </IconButton>
      ),
    };
  }, [onCloseModal]);

  const handleDisputeData = React.useCallback(
    (companyId: string) => {
      args?.onDataDispute?.(companyId);
    },
    [args?.onDataDispute],
  );

  return (
    <Modal
      title={isMobile ? 'My Data' : ''}
      topAction={isMobile ? mobileTopAction : undefined}
      dialogProps={{
        fullWidth: true,
        maxWidth: 'md',
        fullScreen: isMobile,
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <PositionDetailsContent
        employmentData={args?.employmentData}
        onDataDispute={handleDisputeData}
      />
    </Modal>
  );
};
